import {memoize} from 'lodash';
import sailPropInfo from '@stripe/ui-extension-sdk/ui/@sail/ui/internal/docs.json';
import sailChartsPropInfo from '@stripe/ui-extension-sdk/ui/@sail/charts/internal/docs.json';
import dashPropInfo from '@stripe/ui-extension-sdk/ui/@stripe-internal/tailor-dashboard-components/internal/docs.json';

const propInfo = [...sailPropInfo, ...sailChartsPropInfo, ...dashPropInfo];

export const getPropInfo = memoize(
  (component) =>
    propInfo.find(({displayName}) => component === displayName) ?? null,
);
